"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createRoutes", {
    enumerable: true,
    get: function() {
        return createRoutes;
    }
});
const _lage_connect = require("./gen/lage/v1/lage_connect.js");
function createRoutes(serviceImpl) {
    return (router)=>{
        router.service(_lage_connect.LageService, serviceImpl);
    };
}
